import React, { createContext, useContext, useState } from 'react';
import { endOfDay, startOfDay } from 'date-fns';
import { DEFAULT_PAGE_SIZE } from '@components/table';

const AvalancheTableFilterContext = createContext();

export const AvalancheTableFilterContextProvider = ({ children }) => {
  const [startDate, setStartDate] = useState({
    value: new Date(startOfDay(new Date().setDate(new Date().getDate() - 14))),
    disabled: false,
    error: '',
  });
  const [endDate, setEndDate] = useState({ value: new Date(endOfDay(new Date())), disabled: false, error: '' });
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedAvalanchTech, setSelectedAvalancheTech] = useState(null);
  const [selectedEventType, setSelectedEventType] = useState(null);
  const [search, setSearch] = useState('');
  const [scrollPosition, setScrollPosition] = useState(null);
  const [index, setIndex] = useState(0);
  const [defaultPageSize, setDefaultPageSize] = useState(DEFAULT_PAGE_SIZE);

  const stateValues = {
    startDate,
    endDate,
    selectedProgram,
    selectedArea,
    selectedStatus,
    selectedAvalanchTech,
    selectedEventType,
    search,
    scrollPosition,
    index,
    defaultPageSize,
  };

  const stateSetters = {
    setEndDate,
    setStartDate,
    setSelectedProgram,
    setSelectedArea,
    setSelectedStatus,
    setSelectedAvalancheTech,
    setSelectedEventType,
    setSearch,
    setScrollPosition,
    setIndex,
    setDefaultPageSize,
  };

  const contextValues = {
    ...stateValues,
    ...stateSetters,
    //...selectorValues,
    //...memoizedValues,
  };

  return <AvalancheTableFilterContext.Provider value={contextValues}>{children}</AvalancheTableFilterContext.Provider>;
};

export const useAvalancheTableFilterContext = () => useContext(AvalancheTableFilterContext);
